import * as z from 'zod';

export const CheckoutItemTypeSchema = z.enum(['EVENT', 'RACE'])

export type CheckoutItemType = z.infer<typeof CheckoutItemTypeSchema>;